import dayjs from "dayjs";
import { getBestPrice } from "../../../app/api/getBestPrice";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { DefaultEnum, ExpiryCacheTime } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBestPriceRequest, IBestPriceResponse, IPassengerSelection } from "../../../Orchestrator/Types/Index";
import { IGetBestPriceForPopularTripsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";

let popularTripsResults: Array<{ from: string, to: string, date: string | null, price: number | null, currency: string | null }> = [];

class GetBestPriceForPopularTripsAction extends BaseAction<IDefaultActionResult, IGetBestPriceForPopularTripsActionParams> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { from, to } = this.params!;
            const passengerTypes: IPassengerSelection[] = getRecoilStateValue("passengerTypesStateAtom") as IPassengerSelection[];
            if (from && to) {
                let departureDateFrom = dayjs()
                let departureDateTo = dayjs().add(DefaultEnum.defaultInterval, "day")

                const payload: IBestPriceRequest = {
                    departureDateFrom: departureDateFrom.format("YYYY-MM-DD"),
                    departureDateTo: departureDateTo.format("YYYY-MM-DD"),
                    originStop: {
                        stopPlaceRef: from,
                        objectType: "StopPlaceRef"
                    },
                    destinationStop: {
                        stopPlaceRef: to,
                        objectType: "StopPlaceRef"
                    },
                    passengers: [{age: passengerTypes?.find(p => p.id === "adults")?.minAge || 17}],    //set age fix to 12 as we need to always pass one adult
                    currency: "AED"
                }

                const response: any = await getBestPrice(payload, false);
                if (response.status === 'ok' && response.answer) {
                    const bestPriceResponse: IBestPriceResponse = response.answer;
                    const { prices } = bestPriceResponse;
                    let result;
                    if (prices && prices.length > 0) {
                        // Find the lowest price
                        const lowest = prices.reduce((min, curr) => curr.price < min.price ? curr : min, prices[0]);
                        result = {
                            from,
                            to,
                            date: lowest.date,
                            price: lowest.price,
                            currency: lowest.currency
                        };
                    } else {
                        result = {
                            from,
                            to,
                            date: null,
                            price: null,
                            currency: null
                        };
                    }
                    // Add to array
                    popularTripsResults.push(result);

                    // Update atom with all results
                    updateRecoilState("popularTripsPriceAtom", [...popularTripsResults]);

                    actionResult.status = "success";
                    actionResult.data = [...popularTripsResults];
                }
            }
        } catch (error) {
            console.error("Error in GetBestPriceForPopularTripsAction:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const getBestPriceForPopularTripsAction = new GetBestPriceForPopularTripsAction()


